export default __webpack_public_path__ + "static/morgan-wise-261dd106c8e39f18bc1558fd5259f7b2.png";